import {Component, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource, MatTableDataSourcePaginator} from '@angular/material/table';
import {VentanaFlotante} from '../../models/VentanaFlotante';
import {GestionPeticionService} from '../../services/bd/GestionPeticion/gestion-peticion.service';
import {UsuarioService} from "../../services/user.service";
import {AlertArgumentarioComponent} from "../../../VistasGenericas/alert-argumentario/alert-argumentario.component";
import {DetallePeticionAlpComponent} from "../detalle-peticion-alp/detalle-peticion-alp.component";
import {MatSort} from "@angular/material/sort";
@Component({
  selector: 'ral-gestion-peticion-alp',
  templateUrl: './gestion-peticion-alp.component.html',
  styleUrls: ['./gestion-peticion-alp.component.scss']
})
export class GestionPeticionAlpComponent extends VentanaFlotante
{
  token:string ="";
  fechaInicio:Date = new Date();
  fechaFin:Date = new Date();
  estado:string="9";
  matricula : string = "";
  siniestro:string = "";
  telefono : string = "";
  busqueda: string = "Alphabet España Fleet Management";
  displayedColumns: string[] =
  [
    "gestion",
    "id_reparación",
    "created",
    "número_siniestro",
    "matrícula",
    "elemento_afectado",
    "esponsor",
    "nombre_cliente",
    "marca",
    "modelo",
    "versión_vehículo",
    "descripción_daños",
    "nombre_conductor",
    "teléfono",
    "perito",
    "modalidad",
    "vehículo_sustitución",
    "días_vehículo_sustitución",
    "penalización",
    "culpa",
    "observaciones",
    "foto_peritación",
    "cld",
    "estado_contact"
  ];

  peticionesEncontradas:any[] = [];
  dataSource : MatTableDataSource<any> = new MatTableDataSource(this.peticionesEncontradas);
  formInic: any;
  controlGestion:string = "alphabet";
  mostrarCarga:boolean = false;

  @ViewChild(MatPaginator) paginator: MatTableDataSourcePaginator | null=null;
  @ViewChild(MatSort) sort: MatSort| null=null;
  constructor
  (
    public override dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public override data: any | null,
    private dialogDetalle : MatDialog,
    private userService:UsuarioService,
    public peticionWebService: GestionPeticionService,
    public dialog:MatDialog,
  )
  {super(dialogRef, data);}

  ngOnInit()
  {
    this.token = this.data.token;
    this.formInic = this.data.form;
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 1);
    const newData = new Date();
    newData.setDate(newData.getDate() + 1);
    this.fechaFin = newData;
    this.fechaInicio = currentDate;
    this.controlGestion = this.data.tipo ? this.data.tipo.toString() : "alphabet";
    if (this.controlGestion !== "alphabet") {
      if (this.controlGestion === "mobilize") {
        this.busqueda = "OVERLEASE";
      } else {
        this.busqueda = "DRIVALIA";
      }
    }
  }
  setPressed(element: any, isPressed: boolean, event: MouseEvent) {
    event.preventDefault(); // Evita comportamientos no deseados como la selección de texto.
    element.isPressed = isPressed;
  }




  gestionLlamada(row : any, column: string){
    if (column === "gestion"){
      this.cambiarEstado(row);
    }else{
      this.cargarDetalle(row);
    }
  }
  limpiarTabla(){
    this.peticionesEncontradas = [];
    this.dataSource.data = this.peticionesEncontradas;
    this.refrescarDatasource();
  }

  //Abre el Dialog de detalle con la petición seleccionada.
  cargarDetalle(p:any)
  {
    this.dialogDetalle.open(DetallePeticionAlpComponent,
    {
      data:
      {
        peticion: p.cld,
        token:this.data.token,
        padre:this
      }
    }).afterClosed()
    .subscribe(result=>
    {
      if(result != undefined && result != null && result != "")
      {
        this.dialogRef.close(result);
      }
    })
  }
  //*Procesa el tipo de busqueda que se debe hacer
  buscar():void
  {
    if(this.fechaFin.setHours(0,0,0,0) >= this.fechaInicio.setHours(0,0,0,0)){
      this.peticionesEncontradas = [];
      this.mostrarCarga = true;

      let fIniParseada = this.fechaInicio.toISOString().split('T')[0];
      let fFinParseada = this.fechaFin.toISOString().split('T')[0];

      let mFiltros: Map<string, string> = new Map();
      if(this.telefono.trim()!="")mFiltros.set("telefono", this.telefono.trim());
      if(this.siniestro.trim()!="")mFiltros.set("siniestro", this.siniestro.trim());
      if(this.matricula.trim()!="")mFiltros.set("matricula", this.convertirMatriculaGuion(this.matricula.trim()));


      this.peticionWebService.getPeticionAlp(this.token, fIniParseada,fFinParseada,this.estado, this.busqueda.toString(),mFiltros)
        .then(res=>
        {
          this.peticionesEncontradas = res;
          this.dataSource.data = this.peticionesEncontradas;
        })
        .finally(()=>
        {
          this.refrescarDatasource();
          this.mostrarCarga = false;
          if(this.peticionesEncontradas.length==0)
          {
            this.formInic.mostrarArgumentario("Sin resultados",["No se han encontrado datos con los filtros especificados."]);
            this.mostrarCarga=false;
          }
        })
        .catch(err=>{this.mostrarCarga = false;});
    }else{
     this.formInic.mostrarArgumentario("Error", ["La fecha de incio es más grande que la fecha fin"], false, true, true);
    }
  }
  convertirMatriculaGuion(matricula: string): string {
    if (matricula.substring(0, 3) === 'PGC' || matricula.substring(0, 3) === 'DGP') {
      return matricula;
    }

    let matricula2 = '';
    // If the first digit is a number, it's a new format, 4 digits and 3 letters
    if (!isNaN(Number(matricula.charAt(0)))) {
      matricula2 = matricula.substring(0, 4) + '-' + matricula.substring(4);
    } else {
      // If the second character is a number, take the first letter, 4 digits, and the rest of the letters
      if (!isNaN(Number(matricula.charAt(1)))) {
        matricula2 = matricula.substring(0, 1) + '-' + matricula.substring(1, 5) + '-' + matricula.substring(5);
      } else {
        matricula2 = matricula.substring(0, 2) + '-' + matricula.substring(2, 6) + '-' + matricula.substring(6);
      }
    }
    return matricula2;
  }
  onPageChange(event: any)
  {
    if(this.paginator)
      this.paginator.pageIndex = event.pageIndex;
  }
  refrescarDatasource()
  {
    this.dataSource = new MatTableDataSource(this.peticionesEncontradas);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  cambiarEstado(row : any) {
    let estado = row["estado_contact"]

    if (estado == 0){
      const dialogRef = this.formInic.dialog.open(AlertArgumentarioComponent,
        {
          data: {
            titulo: "Atención",
            lineas: ["¿Estas seguro de que quieres marcar esta petición como gestionada?"],
            mostrarBtnAceptar: true
          }
          ,disableClose:true
        });
      dialogRef.afterClosed().subscribe((result: boolean)  => {
        if (result) {
          let paramArr = [];
          let param = {
            "id": row.cld,
            "estado_contact": "1",
            "usuario": this.userService.getNombreCuenta()
          }
          paramArr.push(param);

          this.peticionWebService.UpdateEstadoWeb(this.token, this.controlGestion, paramArr, 0).then(
            res => {
              this.dialog.open(AlertArgumentarioComponent,
                {
                  data: {titulo: "OK",lineas:["Se ha marcado como gestionada!"], mostrarBtnCierre:true},
                  disableClose:false
                }).afterClosed().subscribe(result => this.buscar());
            },
            err => {
              this.formInic.mostrarArgumentario("Error", [err.message], true, true, true);
            }
          )
        }
      });

    }else{
      this.formInic.mostrarArgumentario("Aviso", ["¡No se puede cambiar el estado porque no es 0!"], true, true, true);
    }
  }

}